
export const getTypePriceOption = priceOption => {
    if (!priceOption) return null
    if (priceOption.instant && !priceOption.subscription) return 'instant'
    if (priceOption.subscription && !priceOption.instant) return 'subscription'
    return 'mixed'
}

export const hasHeterogeneousInstallments = (subscription) =>
    Array.isArray(subscription?.installments) && subscription.installments.length > 0

export const getEndBillingDate = subscription => {
    const { startBillingDate, intervalCount, installmentCount } = subscription
    // Convertir el timestamp de Firebase a Date
    const startDate = new Date(startBillingDate.seconds * 1000)
    // Calcular la fecha de finalización: fecha de inicio + (intervalo * número de cuotas - 1) meses
    const endDate = new Date(startDate)
    endDate.setMonth(endDate.getMonth() + (intervalCount * (installmentCount - 1)))
    // Retornar en formato de timestamp de Firebase
    return { seconds: Math.floor(endDate.getTime() / 1000) }
}

